module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"8T3HZFY0CG","searchOnlyApiKey":"4b17c8e0afd4b58868a4650665933cbf","indexName":"prod_index"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/search.json
// module id = 807
// module chunks = 254572558124955